export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Why AMIGO?  ',
  headLine: 'Ray of HOPE in tough times',
  description: 'Provide resources to needed ones',
  buttonLabel: 'Get started',
  imgStart: false,
  img: require('../../Images/aboutus1.svg'),
  alt: 'Aboutus',
  dark: true,
  primary: true,
  darkText: false
};
export const homeObjTwo = {
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Description',
  headLine: 'Help us to spread SMILES to others',
  description:
    'Platform to provide help and resources to those who are in much need, and chance to be a TRUE AMIGO(friend).',
  buttonLabel: 'Discover more',
  imgStart: true,
  img: require('../../Images/aboutus.svg'),
  alt: 'Car',
  dark: false,
  primary: false,
  darkText: true
};
export const homeObjThree = {
  id: 'signup',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Lets create some amigos',
  headLine: 'Help or Get help from others',
  description: 'Join the movement TODAY and help those in need. ',
  buttonLabel: 'Start now',
  imgStart: false,
  img: require('../../Images/join.svg'),
  alt: 'Car',
  dark: false,
  primary: false,
  darkText: true
};
